import { getMutationsForScope, getActionsForScope } from './../utils';
import iframeChannel from '../../iframe-channel';

const mutation = getMutationsForScope('user');
const action = getActionsForScope('user');

const moduleState = {
  loggedIn: false,
  error: null,
  user: null,
  profileFName: null,
  profileLName: null,
  init: false,
};

const moduleGetters = {
  /**
   * If the user made a submission
   *
   * @param {*} state
   * @param {*} getters
   * @param {*} rootState
   * @returns
   */
  madeSubmission(state, getters, rootState) {
    return state.loggedIn && rootState.submission.complete;
  },
};

const mutations = {
  /**
   * Set user login status
   *
   * @param {*} state
   * @param {*} payload
   * @param {Boolean} payload.loggedIn if the user is logged in
   */
  [mutation.USER_SET_LOGIN_STATUS](state, { loggedIn }) {
    state.loggedIn = loggedIn;
  },

  /**
   * Save user info
   *
   * @param {*} state
   * @param {*} { user }
   */
  [mutation.USER_SET_USER](state, { user }) {
    // if (!user || !user.userProfile || !user.userTokens) {
    //   // clear
    //   state.profileFName = null;
    //   state.profileLName = null;
    //   state.user = null;
    //   return;
    // }

    // ({
    //   first_name: state.profileFName,
    //   last_name: state.profileLName
    // } = user.userProfile);

    // if (state.profileLName) {
    //   state.profileLName = state.profileLName.substring(0, 1);
    // }

    state.user = user;
  },

  /**
   * Save user error
   *
   * @param {*} state
   * @param {*} payload
   * @param {Error} payload.error
   */
  [mutation.USER_SET_ERROR](state, { error }) {
    state.error = error;
  },

  /**
   * Save that we've already sent the init message and recieved a response;
   *
   * @param {*} state
   */
  [mutation.USER_SET_INIT](state) {
    state.init = true;
  }
};

const actions = {
  /**
   * Init redbull login SDK: https://stage-account.redbull.com/docs/unified-login.html#_client_side_integration_with_web_properties
   *
   * @param {*} context
   * @returns {Promise.<*>} user object
   */
  [action.USER_INIT]({
    dispatch,
    state,
    commit,
  }) {
    if (state.init) {
      // assume we are already setup
      return { user: state.user };
    }
    console.log('Initalizing rbLogin');

    // rbLoginSDK = new UnifiedLoginSDK.RBAccounts({
    //   dev: DEV || STAGING,
    //   token: RB_LOGIN_TOKEN,
    // });

    // if (DEV) {
    //   window.rbLoginSDK = rbLoginSDK;
    // }

    // // setupEvents
    // rbLoginSDK.onEvent('sessionChecked', (user) => { dispatch(action.USER_UPDATE_USER, { user }); });
    // rbLoginSDK.onEvent('signedIn', (user) => { dispatch(action.USER_UPDATE_USER, { user }); });
    // rbLoginSDK.onEvent('loggedOut', () => dispatch(action.USER_UPDATE_USER));

    // return rbLoginSDK.init()
    //   .then(user => ({ user }))
    //   .catch((error) => {
    //     dispatch(action.USER_HANDLE_ERROR, { error });
    //   });

    return iframeChannel.login()
      .then((user) => {
        commit(mutation.USER_SET_INIT);

        return { user };
      })
      .catch((error) => {
        dispatch(action.USER_HANDLE_ERROR, { error });
      });
  },

  /**
   * Update the user data and status. If there is no user this resets the store
   *
   * @param {*} context
   * @param {Object} [payload]
   * @param {*} [payload.user] the user object
   */
  async [action.USER_UPDATE_USER]({
    commit,
    dispatch,
  },
  {
    user,
  } = {}) {
    if (user) {
      commit(mutation.USER_SET_LOGIN_STATUS, { loggedIn: true });
      commit(mutation.USER_SET_USER, { user });
    } else {
      await dispatch(action.USER_CLEAR_USER);
    }
  },

  /**
   * Clear user (log out)
   *
   * @param {*} context
   */
  [action.USER_CLEAR_USER]({
    commit,
  }) {
    commit(mutation.USER_SET_LOGIN_STATUS, { loggedIn: false });
    commit(mutation.USER_SET_USER, { user: {} });
  },

  /**
   * Login the user. Init sdk if it hasn't already been inited
   *
   * @param {*} context
   * @returns {Promise.<Boolean>} true if the user is logged in
   */
  [action.USER_LOG_IN]({
    state,
    dispatch,
  }) {
    if (!state.init) {
      return dispatch(action.USER_INIT).then(() => dispatch(action.USER_LOG_IN));
    }

    // check if user is logged in
    if (state.loggedIn) {
      return true;
    }

    return iframeChannel.login();
  },

  /**
   * Log out the user
   *
   * @param {*} context
   * @returns {Promise.<*>} resoves with the RB server response
   */
  [action.USER_LOG_OUT]({
    dispatch,
  }) {
    return iframeChannel.logout()
      .then(() => dispatch(action.USER_CLEAR_USER))
      .catch((error) => { dispatch(action.USER_HANDLE_ERROR, { error }); });
  },

  /**
   * Handle user errors
   *
   * @param {*} context
   * @param {*} payload
   * @param {Error} payload.error
   */
  [action.USER_HANDLE_ERROR]({
    commit,
    dispatch,
  },
  {
    error,
  }) {
    // clear user in the event of an error
    dispatch(action.USER_CLEAR_USER);
    // save error
    commit(mutation.USER_SET_ERROR, { error });

    throw error;
  },
};

export default {
  namespaced: true,
  state: moduleState,
  getters: moduleGetters,
  mutations,
  actions,
};
